<template>
  <div v-loading.fullscreen.lock="fullLoading" class="form-container">
    <el-form v-if="beacon" ref="form" :model="beacon" label-width="150px">
      <el-form-item label="識別名稱">
        <el-input v-model="beacon.title"></el-input>
      </el-form-item>
      <el-form-item label="UUID">
        <el-row class="range-content">
          <el-input v-model="beacon.major"></el-input>
          <span class="divider">－</span>
          <el-input v-model="beacon.minor"></el-input>
        </el-row>
      </el-form-item>
      <el-form-item label="RSSI">
        <el-input v-model="beacon.rssi"></el-input>
      </el-form-item>
      <el-form-item label="種類">
        <el-select v-model="beacon.type" placeholder="請選擇種類">
          <el-option label="展品" :value="0"></el-option>
          <el-option label="推播、遊戲" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <!--
      <el-form-item label="使用展間">
        <el-cascader
          v-model="beacon.rooms"
          :options="roomOptions"
          :props="roomProps"
          class="room-options"
          placeholder="選擇展間"
          clearable></el-cascader>
      </el-form-item>
      -->
      <el-form-item label="備註">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5}"
          v-model="beacon.comment"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="tfam-button" plain @click="submitUpdate">更新並儲存</el-button>
        <el-button class="tfam-button" plain @click="goBack">返回至上一層</el-button>
        <el-button class="tfam-button" plain @click="deleteRowData">捨棄這筆資料</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { fetchBeacon, createBeacon, updateBeacon } from "../../api/beacon";
  import { fetchFloorList } from "../../api/floor";

  export default {
    name: "BeaconEdit",
    data() {
      return {
        beaconId: '',
        beacon: undefined,
        fullLoading: false,
        roomList: [],
        roomOptions: [],
        roomProps: { multiple: false },
      }
    },
    methods: {
      getBeacon() {
        this.fullLoading = true;
        fetchBeacon(this.beaconId).then(response => {
          this.fullLoading = false;
          this.beacon = response.data;
        }).catch(err => {
          this.fullLoading = false;
        })
      },
      submitUpdate() {
        if (this.beaconId === 'new') {
          this.fullLoading = true;
          createBeacon(this.beacon).then(response => {
            this.fullLoading = false;
            this.$message({
              type: 'success',
              message: '儲存成功!'
            });
            this.beacon = response.data;
            this.beaconId = this.beacon.beacon_id;
            this.$router.push({
              path: '/beacons/' + this.beacon.beacon_id
            })
          }).catch(err => {
            console.log(err);
            let message = err;
            if (err.response) {
              message = err.response.data.error.message + '!'
            }
            this.$alert(message, '儲存失敗', {
              confirmButtonText: '確定',
              callback: action => {
              }
            });
            this.fullLoading = false;
          })
        } else {
          this.fullLoading = true;
          updateBeacon(this.beaconId, this.beacon).then(response => {
            this.fullLoading = false;
            this.$message({
              type: 'success',
              message: '儲存成功!'
            });
            this.beacon = response.data;
          }).catch(err => {
            console.log(err);
            let message = err;
            if (err.response) {
              message = err.response.data.error.message + '!'
            }
            this.$alert(message, '儲存失敗', {
              confirmButtonText: '確定',
              callback: action => {
              }
            });
            this.fullLoading = false;
          })
        }
      },
      goBack() {
        this.$router.push({
          path: '/beacons'
        })
      },
      deleteRowData() {

      }
    },
    mounted() {
      this.beaconId = this.$route.params.id;
      if (this.beaconId === 'new') {
        this.beacon = {
          beacon_id: 'new',
          name: '',
          major: '',
          minor: '',
          type: 1,
          rssi: -90,
          comment: ''
        }
      } else {
        this.getBeacon();
      }
    }
  }
</script>

<style lang="scss">
  .custom-form-group {
    display: -webkit-box;
    margin: 10px 2rem !important;
    width: 100%;
    .form-item-label {
      width: 150px;
      height: 50px;
      span {
        line-height: 50px;
      }
    }
    .form-item-content {
      width: calc(100% - 150px);
      img {
        width: 400px;
        height: 400px;
        background: darkgrey;
      }
      button {
        display: block;
        margin-top: 5px;
        border-radius: 8px;
      }
    }
    .custom-form-control {
      display: flex;
      button {
        margin: 10px;
      }
    }
  }
</style>

